import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { degrees } from "../../../../_data/degrees";
import { specialities } from "../../../../_data/specialities";
import { languages } from "../../../../_data/languages";
import { allCategories } from "../../../../api/actions/allcategories";
import statesCities from "../../../../_data/statesCities.json";
import ExpertOptions from "./expertOptions";
import { Link } from "gatsby";
export default function AdditionalExpertForm({ handleAdditionalSignup }) {
  const [subTopics, setSubTopics] = React.useState([]);
  const [selectedDegrees, setDegrees] = React.useState([]);
  const [selectedSpecialites, setSpecialities] = React.useState([]);
  const [selectedSubTopics, setSelectedSubTopics] = React.useState([]);
  const [formData, setFormData] = React.useState({
    city: "",
    country: "",
    state: "",
    affiliation: "",
    about_me: "",
    longitude: 0,
    latitude: 0,
  });
  const [errors, setErrors] = React.useState({
    degrees: "",
    specialities: "",
    subTopics: "",
    city: "",
    state: "",
    affiliation: "",
    about_me: "",
  });
  React.useEffect(() => {
    //get all categories
    (async () => {
      const subTopics = await allCategories();
      setSubTopics(subTopics);
    })();
  }, []);

  const handleOptions = (optionType, data) => {
    console.log("HIT");
    if (optionType === "degrees") {
      let degreesArray = [...selectedDegrees];
      const elementIndex = degreesArray.indexOf(data);

      if (elementIndex > -1) {
        degreesArray.splice(elementIndex, 1);
      } else {
        degreesArray.push(data);
      }

      setDegrees(degreesArray);
      return;
    }

    if (optionType === "specialities") {
      let specialitesArray = [...selectedSpecialites];
      const elementIndex = specialitesArray.indexOf(data);

      if (elementIndex > -1) {
        specialitesArray.splice(elementIndex, 1);
      } else {
        specialitesArray.push(data);
      }

      setSpecialities(specialitesArray);
      return;
    }

    if (optionType === "subTopics") {
      let subTopicsArray = [...selectedSubTopics];
      const elementIndex = subTopicsArray.indexOf(data);

      if (elementIndex > -1) {
        subTopicsArray.splice(elementIndex, 1);
      } else {
        subTopicsArray.push(data);
      }

      setSelectedSubTopics(subTopicsArray);
    }
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    setErrors({});
    let errorObj = {};

    if (selectedDegrees.length < 1)
      errorObj.degrees = "You must choose atleast 1 degree";

    if (selectedSpecialites.length < 1)
      errorObj.specialities = "You must choose atleast 1 speciality";

    if (selectedSubTopics.length < 1)
      errorObj.subTopics = "You must choose atleast 1 sub topic";
    if (!formData.state) errorObj.state = "State is required";

    if (!formData.city) errorObj.city = "City is required";

    if (!formData.about_me) errorObj.about_me = "About me is required";

    if (!formData.affiliation) errorObj.affiliation = "Affiliation is required";

    setErrors(errorObj);

    console.log("ERROR OBJ", errorObj);

    if (Object.keys(errorObj).length === 0 && errorObj.constructor === Object) {
      const optionObj = {
        subtopic_ids: selectedSubTopics,
        degree_ids: selectedDegrees,
        speciality_ids: selectedSpecialites,
      };
      const formObj = {
        ...formData,
        ...optionObj,
      };

      console.log("FORM OBJ IN ADDITIONAL", formObj);
      handleAdditionalSignup(formObj);
    }
  };

  return (
    <form onSubmit={onSubmitForm}>
      <h4>
        What <b>Degrees</b> have you obtained *
      </h4>
      {errors.degrees && (
        <span
          style={{
            color: "red",
            marginTop: "-25px",
            display: "block",
            marginBottom: "30px",
          }}
        >
          {errors.degrees}
        </span>
      )}
      <ExpertOptions
        options={degrees}
        optionName="degrees"
        handleOptionChange={handleOptions}
        className="degrees"
      />

      <h4>
        Please Select your <b>Specialities</b> *
      </h4>
      {errors.specialities && (
        <span
          style={{
            color: "red",
            marginTop: "-25px",
            display: "block",
            marginBottom: "30px",
          }}
        >
          {errors.specialities}
        </span>
      )}
      <ExpertOptions
        options={specialities}
        optionName="specialities"
        handleOptionChange={handleOptions}
        className="specialities"
      />

      <h4>
        Please select your <b>Subtopics</b> *
      </h4>
      {errors.subTopics && (
        <span style={{ color: "red" }}>{errors.subTopics}</span>
      )}
      <ExpertOptions
        options={subTopics ? subTopics : []}
        optionName="subTopics"
        handleOptionChange={handleOptions}
        className="subtopics"
      />

      <div className="additional-info">
        <label>
          State
          {errors.state && (
            <span
              style={{
                color: "red",
                fontSize: "14px",
                margin: "0",
                padding: "0",
                texttransform: "capitalize",
              }}
            >
              {errors.state}
            </span>
          )}
        </label>
        <select
          className="form-control"
          name="state"
          value={formData.state}
          onChange={(e) => {
            setFormData({ ...formData, state: e.target.value, city: "" });
          }}
        >
          <option>Select State</option>
          {Object.keys(statesCities).map((state) => (
            <option value={state}>{state}</option>
          ))}
        </select>

        <label>
          City
          {errors.city && (
            <span
              style={{
                color: "red",
                fontSize: "14px",
                margin: "0",
                padding: "0",
                textTransform: "capitalize",
              }}
            >
              {errors.city}
            </span>
          )}
        </label>
        <select
          className="form-control"
          name="city"
          value={formData.city}
          onChange={(e) => {
            setFormData({ ...formData, city: e.target.value });
          }}
        >
          <option>Select City</option>
          {formData.state &&
            statesCities[`${formData.state}`].map((city) => (
              <option value={city}>{city}</option>
            ))}
        </select>

        {/* <label>LANGUAGE</label>
        <select
          className="form-control"
          name="language"
          value={formData.language}
          onChange={(e) => {
            setFormData({ ...formData, languages: e.target.value });
          }}
        >
          <option>Select Language</option>
          {languages.map((language) => (
            <option value={language}>{language}</option>
          ))}
        </select> */}

        <span>
          What is your Affiliation?
          {errors.affiliation && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.affiliation}
            </span>
          )}
        </span>
        <textarea
          className="form-control"
          onChange={(e) =>
            setFormData({ ...formData, affiliation: e.target.value })
          }
          placeholder="Start typing here…"
        ></textarea>

        <span>
          Tell us a little about yourself
          {errors.about_me && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.about_me}
            </span>
          )}
        </span>
        <textarea
          className="form-control"
          onChange={(e) =>
            setFormData({ ...formData, about_me: e.target.value })
          }
          placeholder="Start typing here…"
        ></textarea>

        {/* <Link to="/signup/confirmation"> */}
        <input type="submit" className="next" value="I’m an Expert" />
        {/* </Link> */}
      </div>
    </form>
  );
}
